// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum RestorePointTypes {
    None = 0,
    Exchange = 1,
    OneDrive = 2,
    SharePoint = 4,
    Teams = 8,
    All = 15
}
